<template>
  <div>
    <div v-if="!cellEdited" class="single" :style="[centerAlignStyle, centerButtonStyle]">
      <v-button
        :class="`modification-btn ${btnArrStr[0]}`"
        @click="invokeParentMethod(btnArrStr[0])"
        @keydown="invokeFirstButtonPress"
        v-if="btnArr[0]"
        :disabled="disableButton || !isModificationAllowed(btnArrStr[0])"
        v-b-tooltip
        :title="disabledToolTiptext(btnArrStr[0])"
        ref="button1"
        ><span class="sr-only">{{ params.data.allTickerArray.join(', ') }}</span>
        {{ this.$t(`white-label.widgets.orderStatus.modificationLabel.${btnArrStr[0]}`) }}
      </v-button>
      <v-button
        :class="`modification-btn ${btnArrStr[1]}`"
        @click="invokeParentMethod(btnArrStr[1])"
        @keydown="invokeSecondButtonPress"
        v-if="btnArr[1]"
        :disabled="disableButton || !isModificationAllowed(btnArrStr[1])"
        ref="button2"
        v-b-tooltip
        :title="disabledToolTiptext(btnArrStr[1])"
        ><span class="sr-only">{{ params.data.allTickerArray.join(', ') }}</span>
        {{ this.$t(`white-label.widgets.orderStatus.modificationLabel.${btnArrStr[1]}`) }}
      </v-button>
      <span v-if="params.node.data.index !== 0" class="sr-only">
        {{ this.$t('white-label.widgets.orderStatus.modificationLabel.navigation') }}</span
      >
    </div>
    <div v-if="cellEdited && rootCell" class="single" :style="[centerInlineStyle]">
      <v-button
        :class="`modification-btn update`"
        @keydown.tab="focusCancelUpdateButton"
        @click="invokeParentMethod('Update')"
        :disabled="disableButton"
        ref="update"
        ><span class="sr-only">{{ params.data.allTickerArray.join(', ') }}</span>
        {{ this.$t(`white-label.widgets.orderStatus.modificationLabel.${updateBtn}`) }}
      </v-button>
      <v-button
        class="reset-inline"
        @keydown.tab="focusUpdateButton"
        @keydown.enter="resetEdit"
        @click="resetEdit"
        v-show="!disableButton"
        ref="cancelUpdate"
        ><span class="sr-only">{{ params.data.allTickerArray.join(', ') }}</span>
        <font-awesome-icon icon="times" class="fa-class" />
      </v-button>
    </div>
  </div>
</template>

<script>
import styleVars from '@mm5-components/scss/variables.scss';

import { library as fontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
fontAwesomeLibrary.add(faPlus);

export default {
  name: 'modification-buttons-renderer',
  data() {
    return {
      btnArr: [],
      btnArrStr: ['', ''],
      centerAlignClass: '',
      centerButtonStyle: '',
      disableButton: false,
      updateBtn: 'update'
    };
  },
  methods: {
    refresh(params) {
      this.params = params;
      this.disableButton = false;
      this.updateBtn = 'update';
      this.createButtons();
      return true;
    },
    createButtons() {
      //Reset buttons
      this.btnArr = [];
      this.btnArrStr = ['', ''];
      if (!this.cellEdited) {
        if (this.inlineEdit && this.params.modificationStrArr.length !== 0) {
          this.createModifyButtons(['cancel']);
        } else {
          this.createModifyButtons(this.params.modificationStrArr);
        }
      }
    },
    invokeParentMethod(event) {
      if (event === 'cancel') {
        this.disableButton = true;
        this.params.context.invokeCancelAction(this.params.node);
      } else if (event === 'Update') {
        this.disableButton = true;
        this.updateBtn = 'pending';
        this.params.context.invokeUpdateAction(this.params.node);
      } else {
        this.params.context.invokeModificationAction(this.params.node, event);
      }
    },
    invokeSecondButtonPress(value) {
      this.params.context.invokeTabNextCell(value);
    },
    invokeFirstButtonPress(value) {
      const tabKey = value.key === 'Tab';
      const shiftTabkey = value.shiftKey && value.key === 'Tab';
      if (this.btnArr.length === 2 || (this.btnArr.length === 1 && shiftTabkey)) {
        this.params.context.invokeTabPreviousCell(value);
      } else if (this.btnArr.length === 1 && tabKey) {
        this.params.context.invokeTabNextCell(value);
      }
    },
    focusCancelUpdateButton(event) {
      if (event.shiftKey) this.params.context.invokeTabPreviousCell(event);
      else {
        event.preventDefault();
        this.$refs.cancelUpdate.focus();
      }
    },
    focusUpdateButton(event) {
      if (!event.shiftKey) this.params.context.invokeTabNextCell(event);
      else {
        event.preventDefault();
        this.$refs.update.focus();
      }
    },
    getCenterInlineStyle(index, count) {
      let groupRhMid = (this.rowHeight * count) / 2;
      let centerRh = -1;
      centerRh = Math.floor(groupRhMid - (index + 1) * parseInt(styleVars[`fontSize${this.fontSize.toUpperCase()}`]));
      return { 'padding-top': centerRh + 'px', position: 'relative', bottom: '1px' };
    },
    createModifyButtons(modStrArr) {
      if (modStrArr === undefined) return;
      modStrArr.forEach((modString, index) => {
        this.btnArr[index] = true;
        this.btnArrStr[index] = modString;
      });
      const paramNodeData = this.params.node.data;
      if (paramNodeData.allSameStatus) {
        if (paramNodeData.index === 0) {
          this.centerAlignClass = 'single';
        } else {
          this.btnArr = [false, false];
        }
      } else {
        if (paramNodeData.ftoSecondLegSame) {
          if (paramNodeData.index === 2) {
            this.btnArr = [false, false];
          } else if (paramNodeData.index === 1) {
            this.centerAlignClass = 'single';
          }
        } else {
          this.centerAlignClass = 'single';
        }
      }
    },
    resetEdit() {
      this.params.context.resetEdit(this.params.node);
    },
    isModificationAllowed(action) {
      return action !== 'cancel' && this.params.data.isFractional ? this.isFractionalTradingAllowed : true;
    },
    disabledToolTiptext(action) {
      return !this.isModificationAllowed(action)
        ? this.$t('white-label.widgets.orderStatus.modificationLabel.disabledTooltip')
        : '';
    },
    onKeyDown(e) {
      let isButtonFocussed = e.target.tagName === 'BUTTON';
      let shiftTab = e.shiftKey && e.key === 'Tab';
      if (!this.cellEdited) {
        if (this.btnArr.length === 2) {
          if (!isButtonFocussed && shiftTab) {
            e.preventDefault();
            this.$refs.button2.focus();
          }
        } else if (this.btnArr.length === 1) {
          if (!isButtonFocussed && shiftTab) {
            e.preventDefault();
            this.$refs.button1.focus();
          }
        } else if (this.btnArr.length === 0) {
          const tabKey = e.key === 'Tab';
          const shiftTabkey = e.shiftKey && e.key === 'Tab';
          if (shiftTabkey) this.params.context.invokeTabPreviousCell(e);
          else if (tabKey) this.params.context.invokeTabNextCell(e);
        }
      }
    }
  },
  created() {
    this.params.eGridCell.addEventListener('keydown', this.onKeyDown);
    this.createButtons();
  },
  beforeDestroy() {
    this.params.eGridCell.removeEventListener('keydown', this.onKeyDown);
  },
  computed: {
    centerAlignStyle() {
      const data = this.params.node.data;
      const index = data.index;
      if ((data.allSameStatus && index === 0) || (data.ftoSecondLegSame && index === 1)) {
        const dataCount = data.allTickerArray.length;
        let groupRhMid = (this.rowHeight * dataCount) / 2;
        let centerRh = -1;
        centerRh = Math.floor(groupRhMid - (index + 1) * parseInt(styleVars[`fontSize${this.fontSize.toUpperCase()}`]));
        return { 'padding-top': centerRh + 'px' };
      }
      return '';
    },
    centerInlineStyle() {
      if (this.cellEdited) {
        const data = this.params.node.data;
        if (this.orderStatusTab === 4 || data.allSameStatus) {
          if (data.index == 0) {
            return this.getCenterInlineStyle(data.index, data.allTickerArray.length);
          }
        } else {
          let nodeArrayLength = data.allTickerArray.length;
          if (!this.powerUser) nodeArrayLength = 1;
          if (data.ftoSecondLegSame) {
            nodeArrayLength += 1;
          }
          return this.getCenterInlineStyle(data.index, nodeArrayLength);
        }
      }
      return '';
    },
    rowHeight() {
      return parseInt(styleVars['rowHeight' + this.fontSize.toUpperCase()]);
    },
    fontSize() {
      return this.$store.state.widget[this.params.wid].widgetViewSettings.fontSize || 'm';
    },
    inlineEdit() {
      const orderGroupStatus =
        this.params.data.strategy === 'MLO'
          ? this.params.data.multilegEntry.orderGroupStatus
          : this.params.data.orderGroupStatus;
      return this.$store.state.widget[this.params.wid].inlineEditing && orderGroupStatus === 'OPEN';
    },
    cellEdited() {
      return this.params.data.modifyRendererFlag;
    },
    rootCell() {
      return this.params.data.index === 0;
    },
    orderStatusTab() {
      return this.$store.state.widget[this.params.wid].statusCategoryIndex;
    },
    powerUser() {
      return this.$store.getters['accounts/getOrdersPowerUserFlag'];
    },
    isFractionalTradingAllowed() {
      return this.$store.getters['accounts/isFractionalTradingAllowed'];
    }
  }
};
</script>

<style lang="scss" scoped>
.single {
  display: block !important;
  margin: auto;
}

.reset-inline {
  display: inline-block;
  width: 17px;
  height: 22px;
  text-align: center;
  line-height: 22px;
  border-width: 1px;
  border-style: solid;
  border-color: $gray-400;
  background-color: transparent;
  padding-top: 0px;
  padding-left: 4px;
}

.reset-inline:hover {
  border: 1px solid $red;
  background-color: get-color('red');
}

.fa-class {
  margin-bottom: 3px;
}
.modification-btn {
  flex-grow: 1;
}

.modification-btn.cancel:hover:not(:disabled) {
  border: 1px solid $red;
  background-color: $red-lighten-2;
  color: $black-text;
}

.modification-btn.copy:hover:not(:disabled) {
  border: 1px solid $blue;
  background-color: $blue-lighten-2;
  color: $black-text;
}

.modification-btn.reverse:hover:not(:disabled) {
  border: 1px solid $orange;
  background-color: $orange-lighten-2;
  color: $black-text;
}

.modification-btn.modify:hover:not(:disabled) {
  border: 1px solid $yellow;
  background-color: $yellow;
  color: $black-text;
}

.modification-btn.update:hover:not(:disabled) {
  border: 1px solid $yellow;
  background-color: $yellow;
  color: $black-text;
}

.modification-btn {
  &.focus,
  &:focus {
    border-color: get-color('cyan', 'lighten-1') !important;
  }
}
</style>
